module.exports = __webpack_public_path__ + "img/Intercultool.7f12cd08.jpg";